export default __webpack_public_path__ + "static/media/manitlogo.5c46fcba.png";